import React, { useEffect, useState } from 'react';
import VideoModal from '../../components/VideoModal'
import YouTube from 'react-youtube';
import { AiFillPieChart, AiOutlineAudit, AiOutlineClockCircle, AiOutlinePieChart } from "react-icons/ai";
import { MdGroups, MdIosShare, MdLink, MdLockOpen, MdLogin, MdOpenInNew, MdOutlineFingerprint, MdOutlineVerifiedUser, MdOutlineVideoCameraFront, MdShare, MdVerifiedUser } from 'react-icons/md';
import { ssoData } from '../sso';


const Saml = () => {

  const [open, setOpen] = useState(false);
  const [demoData, setDemoData] = useState();
  const handleOpen = (videoData) => {
    setDemoData(videoData);
    setOpen(true);
  };
  const handleClose = () => setOpen(false);

  const opts = {
    height: '337',
    width: '600',
    playerVars: {
      //   https://developers.google.com/youtube/player_parameters
      autoplay: 1,
      rel: 0
    },
  };

  const playPause = (event) => {
    console.log("event", event.target.pauseVideo())
    event.target.pauseVideo();
  }

  const wpdata = [
    {
      title: "SAML Single Sign-On Setup",
      video: true,
      videoId: "9vT2oKcPYVE",
      videoType: "youtube",
      icon: <MdLockOpen className='text-white fs-5' />
    },
    {
      title: "Role Mapping Based on User Group Attributes",
      video:true,
      videoId: "yyg0TjZ4iao",
      videoType: "youtube",
      icon: <MdGroups className='text-white fs-5' />
    },
    {
      title: " Login using SSO button on wp-login",
      video: true,
      videoId: "LDcCkhaE6cA",
      videoType: "youtube",
      icon: <MdLogin className='text-white fs-5' />
    },
    {
      title: "Login using the SSO link on the site",
      video: true,
      videoId: "G3uEUhXp8Fc",
      videoType: "youtube",
      icon: <MdLink className='text-white fs-4' />
    },
    {
      title: "Auto Redirect from site",
      video: true,
      videoId: "nyxWvDGc3mU",
      videoType: "youtube",
      icon: <MdOpenInNew className='text-white fs-5' />
    },
    {
      title: "Auto Redirect from WP Login",
      video: true,
      videoId: "-E4yqvxJ6qw",
      videoType: "youtube",
      icon: <MdIosShare className='text-white fs-5' />
    }
  ]

  return (
    <>
      <div className='w-100 py-3' style={{ height: '91vh' }}>
        <div className='mx-2 h-auto'>
          <div className='backButton d-flex align-items-center' onClick={() => window.history.back()}>
            <span class="material-symbols-rounded text-dark">
              keyboard_arrow_left
            </span>
            <p className='mb-0'>Back</p>
          </div>
        </div>
        <h4 className='text-center mt-2 h-auto lh-base text-secondary-emphasis fw-bold'> Single Sign On</h4>
        {/* <h5 className='text-center mb-3 h-auto text-secondary'>Single Sign On</h5> */}
        <div className='row justify-content-center h-75 align-items-center mx-5'>
          <div className='col-12 mt-4'>
            <div className='row'>
              
            

                  {ssoData.map((item) => {
                    if(item.video == false){
                    return (
                      <div className='col-4 d-flex justify-content-start my-1'>
                      <div className='p-2 mb-3 d-flex align-items-center ' style={{ width: 'fit-content' }}>

                        <div className='d-flex justify-content-center align-items-center me-2' style={{ height: '40px', width: '40px', borderRadius: '50px', background: '#5177FF' }}>
                          {/* <img src={sso} style={{width:'15px'}}/> */}
                          {item.icon}
                        </div>
                        <p className='mb-0 me-2'>{item.title}</p>

                      </div>
                      </div>
                    )}
                    else{
                      return (
                        <div className='col-4 d-flex justify-content-start my-1'>
                        <div className=' p-2 mb-3 d-flex align-items-center service-button' onClick={() => handleOpen({ "text": item.title, "videoId": item.videoId, "videoType": item.videoType })} style={{ width: 'fit-content' }}>
  
                          <div className='d-flex justify-content-center align-items-center me-2' style={{ height: '40px', width: '40px', borderRadius: '50px', background: '#5177FF' }}>
                            {/* <img src={sso} style={{width:'15px'}}/> */}
                            {item.icon}
                          </div>
                          <p className='mb-0 me-2'>{item.title}</p>
  
                        </div>
                        </div>
                      )
                    }
                  })}

                
            </div>
          </div>
        </div>


      </div>
      <VideoModal
        open={open}
        handleOpen={handleOpen}
        handleClose={handleClose}
        videoData={demoData}
      />
    </>
  )
}

export default Saml